import { IFeed } from '@interfaces/feed';
import dynamic from 'next/dynamic';
import { useViewPopup } from 'src/context/view-media-popup/view-media-popup-container';
import AudioPlayer from '@components/video/player/audio-player/audio-player';
import style from './post-slider.module.scss';

const ImageWithBlurFallback = dynamic(() => import('@components/common/base/image-with-blur'));
const HtmlVideolayer = dynamic(() => import('@components/video/player/html-player'));
// const VideoStatusPlayer = dynamic(() => import('@components/video/player/video-player-with-file-status'));

interface IProps {
  feed: IFeed;
  priority?: boolean;
}

export default function FeedSlider({ feed, priority }: IProps) {
  const { showPopup } = useViewPopup();
  const file = feed.files[0];

  return (
    <div className={style['feed-slider']}>
      {file.type.includes('photo') ? (
        <ImageWithBlurFallback
          key={file._id}
          options={{
            unoptimized: true,
            quality: 80,
            width: file.width || 360,
            height: file.height || 500,
            priority,
            sizes: '(max-width: 768px) 80vw, (max-width: 2100px) 40vw'
          }}
          alt="post-photo"
          fallbackSrc="/no-image.jpg"
          src={file?.url || '/no-image.jpg'}
          onClick={() => {
            showPopup(feed.files, 0);
          }}
        />
      ) : file.type.includes('audio')
        ? (
          <AudioPlayer
            url={file.url}
            playerId={file._id}
            duration={file?.duration || 0}
          />
        )
        : (
          <HtmlVideolayer
            classes="f-vid-player"
            videoSrc={file.url}
            videoId={file._id}
            thumbUrl={file.thumbnails && file.thumbnails[0]}
            priority={priority}
            aspectRatio={file.width && file.height ? file.width / file.height : 16 / 9}
          />
        )}
      {feed.files && feed.files.length > 1 && (
        <div
          className={style['slide-top']}
        >
          <span
            aria-hidden
            className={style.count}
            onClick={() => {
              showPopup(feed.files, 0);
            }}
          >
            {`${1} / ${feed.files.length}`}
          </span>
          {/* <span className={style['btn-grp']}>
            <button type="button" onClick={() => showPopup(feed.files, feed.files.length - 1)}><LeftOutlined /></button>
            <button type="button" onClick={() => showPopup(feed.files, 1)}><RightOutlined /></button>
          </span> */}
        </div>
      )}
    </div>
  );
}

FeedSlider.defaultProps = {
  priority: false
};
